import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import jQuery from "jquery";
import { fb } from "./firebase";
import VueFirestore from "vue-firestore";
import store from "./store"
import Swal from "sweetalert2";
import Datepicker from "vuejs-datepicker";
import Vue2Filters from "vue2-filters";
import moment from "moment";
import DateFilter from "./filters/date";
import DataTables from "datatables.net";
import DataTablesBS4 from "datatables.net-bs4";
import DataTableButtons from "datatables.net-buttons";
import DataTableButtonsBS4 from "datatables.net-buttons-bs4";
import DataTableHTML from "datatables.net-buttons/js/buttons.html5.js";
import V2Table from 'v2-table';
//Vue.use(DataTablesBS4);
//Vue.use(DataTableButtons);
//Vue.use(DataTableButtons);
//Vue.use(DataTableButtonsBS4);
//Vue.use(DataTableHTML);

//Vue.use('datatables.net-buttons/js/buttons.print.js');

Vue.filter('date', DateFilter);

Vue.filter('phone', function (phone) {
  return phone.replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
});

Vue.use(moment);

//Vue.use(DataTables);





Vue.filter("to-uppercase", function (value) {
  return value.toUpperCase();
});

moment().format();

Vue.use(Datepicker);

Vue.use(Vue2Filters);

Vue.use(VueFirestore, {
  key: "id",
  enumerable: true
});

window.Swal = Swal;

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});

window.Toast = Toast;

window.$ = window.jQuery = jQuery;

import "popper.js";
import "bootstrap";
import "./assets/app.scss";
//use bootstrap
import 'bootstrap/dist/css/bootstrap.css'

import 'beautify-scrollbar/dist/index.css';
import 'v2-table/dist/index.css';


Vue.use(V2Table)
/* 
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.flash.js";
import "datatables.net-buttons/js/buttons.print.js"; */


//Vue.component("Navbar", require("./components/Navbar.vue").default);

Vue.config.productionTip = false;

let app = "";
store.dispatch('loadBulksettings')
store.dispatch('loadBulkTypes')
fb.auth().onAuthStateChanged(function (user) {
  store.dispatch("fetchUser", user);
  
  if (!app) {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
});
